
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/GovernanceItem/List', formData);
}

const AddEdit = async (formData: FormData) => {
    return AxiosHelper.post('/GovernanceItem/AddEdit', formData);
}

const Remove = async (formData: FormData) => {
    return AxiosHelper.post('/GovernanceItem/Remove', formData);
}


const GovernanceItemService = {
    List,
    AddEdit,
    Remove
}

export default GovernanceItemService;